<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-19 13:55:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/ShopHeader/index.vue
-->
<template>
  <div class="header_det">
    <div class="text_left shop_name">
      <img src="@/assets/order/icon_shop@2x.png" alt="" class="shop_icon" />
      <span class="font12 font_weight500 line_height_17 colo087 name_name">
        {{ getUserOrder.storeName }}
      </span>
    </div>
    <div
      class="font12 font_weight400 line_height_16 colo038"
      @click="goExplain"
    >
      <img src="@/assets/common/icon_warn@2x.png" alt="" class="exp_icon" />
      <span class="exp_det">{{
        getUserOrder.orderType === 0 ? "发货说明" : "周期购配送规则"
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  methods: {
    goExplain() {
      this.$emit("goExplain");
    }
  }
};
</script>
<style lang="less" scoped>
.header_det {
  display: flex;
  justify-content: space-between;
  padding-right: 12px;
  align-items: center;
}
.shop_name {
  background: #fff;
  padding: 19px 12px;
  font-size: 0;
  .shop_icon {
    width: 20px;
    vertical-align: middle;
  }
  .name_name {
    vertical-align: middle;
    margin-left: 12px;
  }
}
.shop_icon {
  width: 20px;
  vertical-align: middle;
  margin-right: 6px;
}
.exp_icon {
  width: 16px;
  vertical-align: middle;
  margin-right: 4px;
}
.exp_det {
  vertical-align: middle;
}
</style>
